module.exports = __webpack_public_path__ + "static/media/arrow-clockwise.a4d53773.svg";